<div mat-dialog-content class="dialog-content">
  <h3 class="dialog-msg">{{ data.msg }}</h3>
  <mat-form-field appearance="outline" class="reason-field full-width">
    <mat-label>{{ reasonLabel }}</mat-label>
    <textarea matInput [(ngModel)]="reason" [placeholder]="reasonPlaceholder" rows="3"></textarea>
  </mat-form-field>
</div>
<div mat-dialog-actions align="center" class="dialog-actions">
  <button mat-button (click)="cancel()">{{ data.cancelText }}</button>
  <button mat-flat-button color="primary" (click)="confirm()" [disabled]="!canConfirm" cdkFocusInitial>
    {{ data.confirmText }}
  </button>
</div>
